<template>
<div :id="'filepond_'.componentId">
    <file-pond
        :name="name"
        ref="pond"
        :label-idle="translates.addfile"
        :allow-multiple="multiple"
        :accepted-file-types="acceptedFileTypes"
        :server="server"
        :files="files"
        @init="handleFilePondInit"
        @removefile="onFPRemoveFile"
        @addfile="onFPAddFile"
        @processfile="onFPProcessFile"
    />
</div>
</template>

<script>
/**
 * https://pqina.nl/filepond/docs/getting-started/installation/vue/
 * https://github.com/pqina/vue-filepond
 */


import {
    computed, ref, watch, inject
} from 'vue'

import map from 'lodash/map'

// Import Vue FilePond
import vueFilePond from "vue-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";


import {
    useUUID,
} from '~/components/ui/utils'

// Create component
const FilePond = vueFilePond(
    // FilePondPluginFileValidateType,
    FilePondPluginImagePreview
);

export default {
    name: "AFileUploader",

    props: {
        name: {
            type: String,
            required: true,
        },
        server: {
            type: [String, Object],
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        acceptedFileTypes: {
            type: String,
            default: 'image/jpeg, image/png'
        },
        labels: {
            type: Object,
            default: {

            }
        }
    },

    components: {
        FilePond,
    },

    emits: ['update:modelValue'],

    setup(props, ctx) {

        const files = ref([])

        const currentFile = ref(null)

        const pond = ref(null)

        const translates = inject('translates')

        watch(files.value, (value) => {
            ctx.emit('update:modelValue', map(value, 'file'))
        })

        const handleFilePondInit = () => {
            console.log("FilePond has initialized");

            // FilePond instance methods are available on `pond`
        }

        const onFPRemoveFile = (error, file) => {
            console.log('onFPRemoveFile', {error, file})
            if (!error) {
                currentFile.value = null
                const index = files.value.findIndex(f => f.id === file.id)
                if(index > -1) {
                    files.value.splice(index, 1);
                }
            }
        }

        // on file pond add file
        const onFPAddFile = (error, file) => {
            console.log('onFPAddFile', {error, file})
            if (!error) {
                currentFile.value = file.file
                files.value.push(file)
                ctx.emit('onAddFile', currentFile)
            }
        }

        const onFPProcessFile = (error, file) => {
            console.log('onFPProcessFile', {error, file})
            if (!error) {
                ctx.emit('onProcessFile', file)
            }
        }

        return {
            componentId: useUUID(),
            handleFilePondInit,
            onFPProcessFile,
            onFPRemoveFile,
            onFPAddFile,
            translates,
            files,
            pond
        }
    }
}
</script>

<style scoped>

</style>